import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icn-dark-page-indicator-selected.png'
import _imports_1 from '@/assets/images/icn-dark-page-indicator-unselected.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-604a038a")

_pushScopeId("data-v-604a038a")
const _hoisted_1 = { class: "shoppingList-recommendation-pageindicator" }
const _hoisted_2 = {
  key: 0,
  class: "shoppingList-recommendation-pageindicator-image",
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  class: "shoppingList-recommendation-pageindicator-image",
  src: _imports_1
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isSelected)
      ? (_openBlock(), _createBlock("img", _hoisted_2))
      : (_openBlock(), _createBlock("img", _hoisted_3))
  ]))
})